import React, { useState } from 'react';
import './TableView.scss'
import Table from '../../../../../components/moleculesv2/Table/Table';
import Column from '../../../../../components/moleculesv2/Table/Column';
import Status from '../../../../../components/Atomsv2/Status/Status';
import Text from '../../../../../components/Atomsv2/Text/Text';
import Avatar from '../../../../../components/Atomsv2/Avatar/Avatar';
import { formateoBasico } from '../../../../../utilidades/formateos';
import EditarTarea from '../formularios/EditarTarea';

const TableView = ({ data, setData }) => {
    const [tareaEdit, setTareaEdit] = useState(null);


    const statusTemplate = (rowData) => {
        const colores = {
            1: 'default',
            2: 'warning',
            3: 'primary',
            4: 'neutral',
            5: 'success',
            6: 'error',
        }
        const color = colores[rowData.ESTATUS_ID] || '#6c757d';
        return (
            <Status severity={color} >{rowData.ESTATUS}</Status>
        )
    }
    const prioridadTemplate = (rowData) => {
        const colores = {
            3: 'success',
            2: 'warning',
            1: 'error',
        }
        const color = colores[rowData.PRIORIDAD_ID] || '#6c757d';
        return (
            <Status severity={color} >{rowData.PRIORIDAD}</Status>
        )
    }
    const sprintTemplate = (rowData) => {
        const fecha_ini = new Date(rowData.FECHA_INI);
        const fecha_fin = new Date(rowData.FECHA_FIN);
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const fecha_ini_str = fecha_ini.toLocaleDateString('es-MX', options);
        const fecha_fin_str = fecha_fin.toLocaleDateString('es-MX', options);
        return (
            <div >
                <div>{rowData.SPRINT}</div>
                <Text size='extra-small' >{`${fecha_ini_str} - ${fecha_fin_str}`}</Text>
            </div>
        )
    }
    const formatearFecha = (fecha) => {

        const partes = fecha.split("-")
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }
    return (
        <div className='TableView'>
            <Table height='calc(100vh - 170px)' data={data.tareas}>
                <Column sortable header='ID' value='ID'></Column>
                <Column
                    sortable
                    header='TAREA'
                    value='TAREA'
                    onClick={(rowData) => setTareaEdit(rowData)}
                    body={(rowData) => (
                        <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                            {rowData.TAREA}
                        </span>
                    )}
                ></Column>
                <Column sortable header='AREA' value='AREA' body={(rowData) => { return rowData.AREA == null ? 'Sin asignar' : rowData.AREA }}></Column>
                <Column sortable header='DESCRIPCION' value='DESCRIPCION'></Column>
                <Column sortable header='ESTATUS' value='ESTATUS' body={statusTemplate}></Column>
                <Column sortable header='PRIORIDAD' value='PRIORIDAD' body={prioridadTemplate}></Column>
                <Column sortable header='PROYECTO' value='PROYECTO'></Column>
                <Column sortable header='SPRINT' value='SPRINT' body={sprintTemplate}></Column>
                <Column sortable header='FECHA_INI' value='FECHA_INI' body={(rowData) => { return (<>{formatearFecha(formateoBasico(rowData.FECHA_INI))}</>) }}></Column>
                <Column sortable header='FECHA_FIN' value='FECHA_FIN' body={(rowData) => { return (<>{formatearFecha(formateoBasico(rowData.FECHA_FIN))}</>) }}></Column>
                <Column sortable header='CREADO POR ' value='USUARIO_CREACION_NOMBRE'></Column>
                <Column sortable header='ASIGNADO A' value='USUARIO_ASIGNADO_NOMBRE' body={(rowData) => (
                    rowData.USUARIO_ASIGNADO_NOMBRE
                        ? <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <Avatar src={rowData.USUARIO_ASIGNADO_FOTO} label={rowData.USUARIO_ASIGNADO_NOMBRE} size="small" />
                            <span>{rowData.USUARIO_ASIGNADO_NOMBRE.trim()}</span>
                          </div>
                        : <span>—</span>
                )}></Column>
            </Table>

            <EditarTarea
                open={!!tareaEdit}
                onClose={() => setTareaEdit(null)}
                tarea={tareaEdit}
                data={data}
                setData={setData}
            />
        </div>
    )
}
export default TableView